export default __webpack_public_path__ + "static/media/cio.bce12088.png";